// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-map-tile {
  min-width: 0;
  padding: 18px 20px;

  display: flex;
  align-items: center;

  background: #f7faf7;
  border: 1px solid #c8d9ce;
  border-radius: 14px;

  box-sizing: border-box;
}

.summary-map-preview {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.summary-map-label {
  color: #526159;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.summary-map-preview strong {
  margin-top: 6px;

  color: #17211a;
  font-size: 1.35rem;
  line-height: 1.2;
}

.summary-map-preview p {
  margin: 7px 0 14px;

  color: #617067;
  font-size: 0.8rem;
  line-height: 1.4;
}

.summary-map-button {
  min-height: 40px;
  padding: 9px 13px;

  color: #ffffff;
  background: #277a3e;
  border: 1px solid #277a3e;
  border-radius: 9px;

  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 700;

  cursor: pointer;
}

.summary-map-button:hover:not(:disabled) {
  background: #17552a;
  border-color: #17552a;
}

.summary-map-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/SummaryBar/SummaryMapTile.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;;EAEnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;;EAEnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;;EAEX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;;EAEf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;;EAElB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;;EAEhB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".summary-map-tile {\n  min-width: 0;\n  padding: 18px 20px;\n\n  display: flex;\n  align-items: center;\n\n  background: #f7faf7;\n  border: 1px solid #c8d9ce;\n  border-radius: 14px;\n\n  box-sizing: border-box;\n}\n\n.summary-map-preview {\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.summary-map-label {\n  color: #526159;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.summary-map-preview strong {\n  margin-top: 6px;\n\n  color: #17211a;\n  font-size: 1.35rem;\n  line-height: 1.2;\n}\n\n.summary-map-preview p {\n  margin: 7px 0 14px;\n\n  color: #617067;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.summary-map-button {\n  min-height: 40px;\n  padding: 9px 13px;\n\n  color: #ffffff;\n  background: #277a3e;\n  border: 1px solid #277a3e;\n  border-radius: 9px;\n\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 700;\n\n  cursor: pointer;\n}\n\n.summary-map-button:hover:not(:disabled) {\n  background: #17552a;\n  border-color: #17552a;\n}\n\n.summary-map-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
